import { helpers, required, maxLength } from '@vuelidate/validators';
import { messageContent } from '@/common/messageContent.js';

export const campaignsCategoryValidation = {
  categoryData: {
    categoryName: {
      required: helpers.withMessage(messageContent.requireInput('カテゴリ名'), required),
      maxlength: helpers.withMessage(
        messageContent.requireUnderMaximumNumberOfCharacters('カテゴリ名', 5),
        maxLength(5)
      ),
    },
  },
};
